












































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import http from "@/axios/http-common";
import criticalLabResultService from "@/services/criticalLabResultService";
import CountdownTimer from "./CountdownTimer.vue";
import PeriodicReportTabs from "./PeriodicReportTabs.vue";
import RcaBuilder from "./RcaBuilder.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";

@Component({
  components: { CountdownTimer, PeriodicReportTabs, RcaBuilder, UnitRuangPicker }
})
export default class CriticalLabResultEventForm extends Vue {
  @Prop({ default: null }) eventData!: any;
  @Prop({ default: false }) isEdit!: boolean;

  saving = false;
  thresholds: any[] = [];
  reasonDefinitions: any[] = [];
  petugasOptions: any[] = [];
  dpjpOptions: any[] = [];
  selectedThreshold: any = null;
  rcaItems: any[] = [];

  form: any = {
    tanggal_pelaporan: localISODate(),
    unit_laboratorium: "",
    shift: "",
    nama_petugas_pelapor_id: null,
    nama_petugas_pelapor: "",
    nama_analis_verifikator_id: null,
    nama_analis_verifikator: "",
    pasien_id: "",
    nama_pasien: "",
    no_rekam_medis: "",
    unit_asal_pasien: "",
    unit_tujuan_id: null,
    dpjp_id: null,
    dpjp_nama: "",
    dpjp_kontak: "",
    jenis_pemeriksaan: "",
    parameter_kritis: "",
    nilai_hasil: "",
    satuan: "",
    rentang_kritis: "",
    loinc_code: "",
    interpretasi_flag: "",
    kategori_kritis: "",
    threshold_id: null,
    t0_jam_hasil_kritis_diterima: "",
    t1_jam_dilaporkan_ke_dpjp: "",
    metode_pelaporan: "",
    penerima_laporan_id: null,
    penerima_laporan_nama: "",
    readback_dilakukan: false,
    waktu_pelaporan_menit: null,
    status_tercapai: null,
    reason_ids: [],
    alasan_tidak_tercapai_uraian: "",
    rca_items: [],
  };

  unitLabOptions = [
    { text: "Patologi Klinik", value: "patologi_klinik" },
    { text: "Mikrobiologi", value: "mikrobiologi" },
    { text: "Patologi Anatomi", value: "patologi_anatomi" },
    { text: "Bank Darah", value: "bank_darah" },
  ];

  shiftOptions = [
    { text: "Pagi (07-14)", value: "pagi" },
    { text: "Sore (14-21)", value: "sore" },
    { text: "Malam (21-07)", value: "malam" },
  ];

  unitPasienOptions = [
    { text: "IGD", value: "igd" }, { text: "Rawat Jalan", value: "ralan" },
    { text: "Rawat Inap", value: "ranap" }, { text: "ICU", value: "icu" },
    { text: "HCU", value: "hcu" }, { text: "PICU", value: "picu" },
    { text: "NICU", value: "nicu" }, { text: "ICCU", value: "iccu" },
    { text: "Kamar Bersalin", value: "kamar_bersalin" },
  ];

  metodePelaporanOptions = [
    { text: "Telepon + Read-back", value: "telepon_readback" },
    { text: "WhatsApp + Read-back", value: "wa_readback" },
    { text: "Tatap Muka", value: "tatap_muka" },
    { text: "Tulis di CPPT", value: "tulis_di_cppt" },
  ];

  kategoriKritisOptions = [
    { text: "Kritis Tinggi", value: "kritis_tinggi" },
    { text: "Kritis Rendah", value: "kritis_rendah" },
    { text: "Kritis Panik", value: "kritis_panik" },
  ];

  get showRcaTab(): boolean {
    return this.form.status_tercapai === "tidak_tercapai";
  }

  async mounted() {
    await Promise.all([
      this.loadThresholds(),
      this.loadReasonDefinitions(),
      this.loadPetugasList(),
      this.loadDpjpList(),
    ]);
    if (this.eventData) {
      Object.assign(this.form, this.eventData);
      // Fix tanggal format dari API (ISO string → YYYY-MM-DD)
      if (this.eventData.tanggal_pelaporan) {
        this.form.tanggal_pelaporan = String(this.eventData.tanggal_pelaporan).substring(0, 10);
      }
      // Fix datetime format dari API (ISO string → YYYY-MM-DDTHH:mm)
      if (this.eventData.t0_jam_hasil_kritis_diterima) {
        this.form.t0_jam_hasil_kritis_diterima = String(this.eventData.t0_jam_hasil_kritis_diterima).substring(0, 16).replace(" ", "T");
      }
      if (this.eventData.t1_jam_dilaporkan_ke_dpjp) {
        this.form.t1_jam_dilaporkan_ke_dpjp = String(this.eventData.t1_jam_dilaporkan_ke_dpjp).substring(0, 16).replace(" ", "T");
      }
      this.form.reason_ids = (this.eventData.reasons || []).map((r: any) => r.id);
      this.rcaItems = this.eventData.rca_items || [];
    }
  }

  async loadThresholds() {
    try {
      const res = await criticalLabResultService.getThresholds();
      this.thresholds = res.data?.data || [];
    } catch (e) { /* ignore */ }
  }

  async loadReasonDefinitions() {
    try {
      const res = await criticalLabResultService.getReasonDefinitions();
      this.reasonDefinitions = res.data?.data || [];
    } catch (e) { /* ignore */ }
  }

  async loadPetugasList() {
    try {
      const res = await http.getData("/combo/dokter");
      const list = (res.data || []).map((d: any) => ({
        id: d.user_id,
        nama: d.nama,
        hp: d.hp || "",
      }));
      this.petugasOptions = list;
    } catch (e) {
      this.petugasOptions = [];
    }
  }

  async loadDpjpList() {
    try {
      const res = await http.getData("/combo/dokter-with-hp");
      const list = (res.data || []).map((d: any) => ({
        id: d.user_id,
        nama: d.nama,
        hp: d.hp || "",
        spesialisasi: d.idsp || "",
      }));
      this.dpjpOptions = list;
    } catch (e) {
      // Fallback ke endpoint tanpa HP
      try {
        const res2 = await http.getData("/combo/dokter");
        this.dpjpOptions = (res2.data || []).map((d: any) => ({
          id: d.user_id,
          nama: d.nama,
          hp: "",
          spesialisasi: d.idsp || "",
        }));
      } catch (e2) {
        this.dpjpOptions = [];
      }
    }
  }

  onThresholdChange(threshold: any) {
    if (!threshold) return;
    this.form.parameter_kritis = threshold.parameter_nama;
    this.form.satuan = threshold.satuan;
    this.form.loinc_code = threshold.loinc_code;
    this.form.rentang_kritis = threshold.deskripsi_rentang;
    this.form.threshold_id = threshold.id;
    this.form.jenis_pemeriksaan = threshold.kategori_pemeriksaan;
  }

  async evaluateThreshold() {
    if (!this.selectedThreshold || !this.form.nilai_hasil) return;
    try {
      const res = await criticalLabResultService.evaluateThreshold({
        parameter_kode: this.selectedThreshold.parameter_kode,
        nilai: this.form.nilai_hasil,
      });
      const data = res.data?.data;
      if (data) {
        this.form.interpretasi_flag = data.flag;
      }
    } catch (e) { /* ignore */ }
  }

  @Watch("form.t0_jam_hasil_kritis_diterima")
  @Watch("form.t1_jam_dilaporkan_ke_dpjp")
  computeTime() {
    if (this.form.t0_jam_hasil_kritis_diterima && this.form.t1_jam_dilaporkan_ke_dpjp) {
      const t0 = new Date(this.form.t0_jam_hasil_kritis_diterima).getTime();
      const t1 = new Date(this.form.t1_jam_dilaporkan_ke_dpjp).getTime();
      const diffMin = Math.round((t1 - t0) / 60000);
      this.form.waktu_pelaporan_menit = diffMin;
      this.form.status_tercapai = diffMin < 30 ? "tercapai" : "tidak_tercapai";
    }
  }

  onPetugasChange(id: number) {
    const p = this.petugasOptions.find((o: any) => o.id === id);
    if (p) this.form.nama_petugas_pelapor = p.nama;
  }

  onAnalisChange(id: number) {
    const p = this.petugasOptions.find((o: any) => o.id === id);
    if (p) this.form.nama_analis_verifikator = p.nama;
  }

  onDpjpChange(id: number) {
    const d = this.dpjpOptions.find((o: any) => o.id === id);
    if (d) {
      this.form.dpjp_nama = d.nama;
      this.form.dpjp_kontak = d.hp || "";
    }
  }

  async saveEvent() {
    this.saving = true;
    try {
      const payload = { ...this.form };
      if (this.rcaItems.length > 0) {
        payload.rca_items = this.rcaItems;
      }

      if (this.eventData && this.eventData.id) {
        await criticalLabResultService.updateEvent(this.eventData.id, payload);
      } else {
        await criticalLabResultService.createEvent(payload);
      }
      this.$emit("saved");
    } catch (e) {
      const err = e as any;
      alert(err.response?.data?.message || "Gagal menyimpan.");
    } finally {
      this.saving = false;
    }
  }

  async signTier(tier: string) {
    if (!this.eventData?.id) return;
    try {
      await criticalLabResultService.signEvent(this.eventData.id, { tier });
      const res = await criticalLabResultService.getEvent(this.eventData.id);
      Object.assign(this.form, res.data?.data);
    } catch (e) {
      const err = e as any;
      alert(err.response?.data?.message || "Gagal sign.");
    }
  }

  downloadPdf() {
    if (!this.eventData?.id) return;
    window.open(criticalLabResultService.getPdfUrl(this.eventData.id), "_blank");
  }

  flagColor(flag: string) {
    if (flag === "HH") return "red";
    if (flag === "LL") return "blue";
    return "orange";
  }

  formatDateTime(dt: string) {
    if (!dt) return "-";
    return new Date(dt).toLocaleString("id-ID");
  }
}
